import { useRootStore } from "store";
import UserSettings from "../components/UserSettings";

export default function CustomerServerSettings() {
  const { isAuthenticated } = useRootStore((state) => state.user);

  return (
    <>
      {isAuthenticated && (
        <div className="box">
          <h1>Mina inställningar</h1>
          <hr className="header-border" />
          <UserSettings />
        </div>
      )}
    </>
  );
}
